import { useState } from "react";
import {
  FaEnvelope,
  FaUser,
  FaPhoneAlt,
  FaServicestack,
  FaRegFileAlt,
} from "react-icons/fa";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    service: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch("https://api.atronm.com/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await res.json();
      if (res.ok) {
        alert(" Message sent successfully!");
        setFormData({
          name: "",
          email: "",
          phone: "",
          service: "",
          message: "",
        });
      } else {
        alert(data.error || " Failed to send message.");
      }
    } catch (err) {
      alert(" Error sending message.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="min-h-screen bg-gradient-to-b from-white to-gray-100 px-6 py-16">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        
        <div className="text-gray-800 space-y-6">
          <h2 className="text-4xl font-bold leading-tight">
            Let’s Build Something Great Together 
          </h2>
          <p className="text-lg text-gray-600">
            Whether you're looking to launch a new product, improve an existing
            system, or just explore possibilities with AI, web development, or
            custom software, we're here to help.
          </p>
          <ul className="list-disc pl-6 text-gray-700 space-y-2">
            <li>AI-Powered Smart Solutions</li>
            <li>Custom Web & Mobile Applications</li>
            <li>End-to-End Software Development</li>
            <li>One-on-One Consultation for Strategy</li>
          </ul>
          <p className="text-md text-gray-500 italic">
            Fill out the form and we’ll get back to you shortly!
          </p>
        </div>

        
        <form
          className="bg-white shadow-xl rounded-lg p-8 space-y-6"
          onSubmit={handleSubmit}
        >
          <div className="flex items-center gap-3 border-b border-gray-300 focus-within:border-blue-600 transition">
            <FaUser className="text-gray-400" />
            <input
              className="w-full p-3 outline-none"
              type="text"
              name="name"
              placeholder="Your Name"
              required
              value={formData.name}
              onChange={handleChange}
            />
          </div>

          <div className="flex items-center gap-3 border-b border-gray-300 focus-within:border-blue-600 transition">
            <FaEnvelope className="text-gray-400" />
            <input
              className="w-full p-3 outline-none"
              type="email"
              name="email"
              placeholder="Your Email"
              required
              value={formData.email}
              onChange={handleChange}
            />
          </div>

          <div className="flex items-center gap-3 border-b border-gray-300 focus-within:border-blue-600 transition">
            <FaPhoneAlt className="text-gray-400" />
            <input
              className="w-full p-3 outline-none"
              type="tel"
              name="phone"
              placeholder="Your Phone Number"
              required
              value={formData.phone}
              onChange={handleChange}
            />
          </div>

          <div className="flex items-center gap-3 border-b border-gray-300 focus-within:border-blue-600 transition">
            <FaServicestack className="text-gray-400" />
            <select
              name="service"
              required
              className="w-full p-3 outline-none bg-transparent"
              value={formData.service}
              onChange={handleChange}
            >
              <option value="" disabled>
                Select a Service
              </option>
              <option value="AI Development">AI Development</option>
              <option value="Web Development">Web Development</option>
              <option value="App Development">App Development</option>
              <option value="Cloud & DevOps">Cloud & DevOps</option>
              <option value="Custom Software">Custom Software</option>
            </select>
          </div>

          <div className="flex items-start gap-3 border-b border-gray-300 focus-within:border-blue-600 transition">
            <FaRegFileAlt className="mt-3 text-gray-400" />
            <textarea
              className="w-full p-3 outline-none"
              name="message"
              placeholder="Project Details or Message"
              rows="4"
              required
              value={formData.message}
              onChange={handleChange}
            ></textarea>
          </div>

          <button
            className="w-full bg-blue-600 text-white py-3 rounded-md font-semibold hover:bg-blue-700 transition"
            type="submit"
            disabled={loading}
          >
            {loading ? "Sending..." : "Send Message"}
          </button>
        </form>
      </div>
    </section>
  );
}
